import { render, staticRenderFns } from "./ApproveMessageDialog.vue?vue&type=template&id=413923ec"
import script from "./ApproveMessageDialog.vue?vue&type=script&lang=js"
export * from "./ApproveMessageDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports